import {
  UPDATE_LUNG,
  GET_LUNG_TOTAL_SUCCESS,
  GET_LUNG_TOTAL_FAIL,
} from "../actions/_actionType";
// "service/actions/_actionType";
export default function lungRe(
  state = {
    lungData: {
      age: 40,
      sex: true,
      kg: 70,
      cm: 170,
      dmyn: false, // 당뇨
      pye: false, // 폐기종
      tbsick: false, // 운동량
      smoking: false,
      smokingGap: 0,
      gapYear: 0,
    },
    total: 0,
    complete: false,
  },
  action
) {
  switch (action.type) {
    case UPDATE_LUNG:
      return {
        ...state,
        lungData: action.payload.datas,
      };
    case GET_LUNG_TOTAL_SUCCESS:
      return {
        ...state,
        total: action.total,
        complete: true,
      };
    case GET_LUNG_TOTAL_FAIL:
      return {
        ...state,
        total: action.total,
        complete: true,
      };

    default:
      return state;
  }
}
